import React from 'react';
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const PrivacyPolicy = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Privacy Policy" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{height:"400px"}} data-black-overlay="1" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one cust-title mt-5">{t('politiqueConfidentialite.title')}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                {/* Start Description Area  */}
                <div className="rn-service-area pt-5 pb-5">
                    <div className="container">
                        <p className="description" style={{ fontSize: '20px',textAlign:'center' }}>{t('politiqueConfidentialite.content')}</p>
                    </div>
                </div>
                {/* End Description Area  */}

                <Separator />   
                {/* Start 1.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe1.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe1.content')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 1.  */}
                <Separator />
                {/* Start 2.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe2.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe2.content')}</p>
                                            <li>{t('politiqueConfidentialite.paragraphe2.list1')}</li>
                                            <li>{t('politiqueConfidentialite.paragraphe2.list2')}</li>
                                            <li>{t('politiqueConfidentialite.paragraphe2.list3')}</li>
                                            <p>{t('politiqueConfidentialite.paragraphe2.list4')}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 2.  */}
                <Separator />
                {/* Start 3.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe3.title')}</h3>
                                        <p>{t('politiqueConfidentialite.paragraphe3.content')}</p>
                                        <div className='row'>
                                            <div className='col-lg-2'>
                                                <h5>{t('politiqueConfidentialite.paragraphe3.chartTitlecol1')}</h5>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow1Col1')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-2'>
                                                <h5>{t('politiqueConfidentialite.paragraphe3.chartTitlecol2')}</h5>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow1Col2')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-4'>
                                                <h5>{t('politiqueConfidentialite.paragraphe3.chartTitlecol3')}</h5>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow1Col3')}</p>
                                            </div>
                                        </div>
                                        <Separator />
                                        <div className='row pt-3'>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow2Col1')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow2Col2')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-4'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow2Col3')}</p>
                                            </div>
                                        </div>
                                        <Separator />
                                        <div className='row pt-3'>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow3Col1')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow3Col2')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-4'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow3Col3')}</p>
                                            </div>
                                        </div>
                                        <Separator />
                                        <div className='row pt-3'>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow4Col1')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow4Col2')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-4'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow4Col3')}</p>
                                            </div>
                                        </div>
                                        <Separator />
                                        <div className='row pt-3'>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow5Col1')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-2'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow5Col2')}</p>
                                            </div>
                                            <div className='col-lg-1'></div>
                                            <div className='col-lg-4'>
                                                <p>{t('politiqueConfidentialite.paragraphe3.chartrow5Col3')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 3.  */}
                <Separator />
                {/* Start 4.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe4.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe4.content')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe4.chartrow1Col1')} {t('politiqueConfidentialite.paragraphe4.chartrow1Col2')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe4.chartrow2Col1')} {t('politiqueConfidentialite.paragraphe4.chartrow2Col2')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe4.chartrow3Col1')} {t('politiqueConfidentialite.paragraphe4.chartrow3Col2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 4.  */}
                <Separator />
                {/* Start 5.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe5.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe5.content')}</p>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow1Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow1Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow2Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow2Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow3Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe5.chartrow3Col2')}</td>
                                            </tr>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 5.  */}
                <Separator />
                {/* Start 6.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe6.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe6.content')}</p>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow1Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow1Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow2Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow2Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow3Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow3Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow4Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow4Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow5Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow5Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow6Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow6Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow7Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow7Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow8Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow8Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow9Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow9Col2')}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow10Col1')}</td>
                                                <td>{t('politiqueConfidentialite.paragraphe6.chartrow10Col2')}</td>
                                            </tr>
                                            <p className='pt-5'>{t('politiqueConfidentialite.paragraphe6.content2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 6.  */}
                <Separator />
                {/* Start 7.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe7.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe7.content')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 7.  */}
                <Separator />
                {/* Start 8.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe8.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe8.content')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe8.chartrow1Col2')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe8.chartrow2Col2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 8.  */}
                <Separator />
                {/* Start 9.  */}
                <div className="about-area about-style-4 pt-5 pb-5">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-12 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t('politiqueConfidentialite.paragraphe9.title')}</h3>
                                            <p>{t('politiqueConfidentialite.paragraphe9.content')}</p>
                                            <p>{t('politiqueConfidentialite.paragraphe9.content2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End 9.  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default PrivacyPolicy
